import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { Box, Typography } from "@mui/material";
import DownloadButton from "./DownloadCv";

// Configuration du worker PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const PdfPreview = ({ fileUrl, fileName }) => {
    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <Box sx={{
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                overflow: "auto",
                background: '#242424',
                borderRadius: '8px',
                py: 2,
                px: { xs: 1, md: 2 },
                '& .react-pdf__Page': {
                    margin: '0 auto 18px',
                    boxShadow: '0 12px 34px rgba(0,0,0,0.38)',
                },
                '& .react-pdf__Page__canvas': {
                    maxWidth: '100%',
                    height: 'auto !important',
                },
            }}>
                <Document
                    file={fileUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<Typography sx={{ color: '#fff' }}>Chargement du PDF...</Typography>}
                    error={<Typography color="error">Erreur lors du chargement du PDF</Typography>}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            renderTextLayer={true}
                            renderAnnotationLayer={true}
                            scale={1.35}
                        />
                    ))}
                </Document>
            </Box>
            <DownloadButton
                fileUrl={fileUrl}
                fileName={fileName}
            />
        </Box>
    );
};

export default PdfPreview;
